import { useActingRole } from '@/shared/session/useActingRole';
import { NAV_ITEMS, accountMayOpen, type NavItem } from './navigation';

/** The pages the acting role can open. */
export function useNavItems(): readonly NavItem[] {
  const { role, demo, accountRole } = useActingRole();
  return NAV_ITEMS.filter((item) => item.roles.includes(role) && accountMayOpen(item.path, accountRole, demo));
}
